(function(){"use strict";try{if(typeof document<"u"){var o=document.createElement("style");o.appendChild(document.createTextNode('._switch_1d6s8_1{--swui-switch-width: 50px;--swui-switch-height: var(--swui-field-box-size-medium);--swui-switch-animation-time: var(--swui-animation-time-medium);--swui-switch-selected-highlight-color: var(--lhds-color-blue-500);--swui-switch-knob-width: calc(var(--swui-switch-height) - 2px);--swui-switch-knob-bg-color-enabled: var(--swui-handle-bg-enabled-color);--swui-switch-knob-bg-color-disabled: var(--swui-handle-bg-disabled-color);--swui-switch-container-bg-color-enabled: var(--swui-field-bg-enabled);--swui-switch-container-bg-color-disabled: var(--swui-field-bg-disabled);--swui-switch-knob-border-color-enabled: var(--swui-separator-color);--swui-switch-container-border-color: var(--swui-field-border-color);--swui-switch-container-border-color-hover: var( --swui-field-border-color-hover );--swui-switch-container-border-color-disabled: var( --swui-field-border-color-disabled );--swui-switch-knob-shadow-color: var(--swui-field-shadow-color);display:flex;flex-direction:row;border:1px solid var(--swui-switch-container-border-color);box-sizing:border-box;background-color:var(--swui-switch-container-bg-color-enabled);height:var(--swui-switch-height);width:var(--swui-switch-width);border-radius:calc(var(--swui-switch-height) / 2);padding:0;margin:0;cursor:pointer;transition:background-color var(--swui-switch-animation-time)}._switch_1d6s8_1:focus{outline:0}._switch_1d6s8_1:focus-visible{outline:var(--swui-focus-outline);outline-offset:2px;border:1px solid var(--swui-switch-selected-highlight-color)}._switch_1d6s8_1:hover{border:1px solid var(--swui-switch-selected-highlight-color)}._switch_1d6s8_1:disabled{cursor:default;background-color:var(--swui-switch-container-bg-color-disabled);border:1px solid var(--swui-switch-container-border-color-disabled)}._switch_1d6s8_1:disabled ._knob_1d6s8_56{background-color:var(--swui-switch-knob-bg-color-disabled)}._switch_1d6s8_1 ._filler_1d6s8_61{flex:none;transition:flex var(--swui-switch-animation-time)}._switch_1d6s8_1 ._knob_1d6s8_56{width:var(--swui-switch-knob-width);height:var(--swui-switch-knob-width);border-radius:50%;background-color:var(--swui-switch-knob-bg-color-enabled);box-shadow:var(--swui-switch-knob-shadow-color) 0 0 4px 1px}._checked_1d6s8_75{border:1px solid var(--swui-switch-selected-highlight-color);background-color:var(--swui-switch-selected-highlight-color)}._checked_1d6s8_75 ._filler_1d6s8_61{flex:1}._checkbox_1ndou_1{--swui-checkbox-height: var(--swui-field-box-size-medium);--swui-checkbox-height-small: var(--swui-field-box-size-small);--swui-checkbox-border-radius: var(--swui-field-border-radius);--swui-checkbox-animation-time: var(--swui-animation-time-medium);--swui-checkbox-icon-color: var(--swui-field-indicator-active-color);--swui-checkbox-disabled-icon-color: var(--swui-text-disabled-color);--swui-checkbox-unchecked-icon-color: var( --swui-field-indicator-inactive-color );--swui-checkbox-unchecked-bg-color: var(--swui-white);--swui-checkbox-checked-bg-color: var(--lhds-color-blue-500);--swui-checkbox-disabled-bg-color: var(--swui-field-bg-disabled);--swui-checkbox-disabled-checked-bg-color: var(--swui-field-bg-disabled);--swui-checkbox-border-color: var(--swui-field-border-color);--swui-checkbox-border-hover-color: var(--swui-field-border-color-hover);--swui-checkbox-disabled-border-color: var(--swui-checkbox-disabled-bg-color);-webkit-appearance:none;-moz-appearance:none;border-radius:var(--swui-checkbox-border-radius);outline:none;display:inline-block;vertical-align:top;position:relative;margin:0;cursor:pointer;border:1px solid var(--current-border-color, var(--swui-checkbox-border-color));background:var(--current-bg-color, var(--swui-checkbox-unchecked-bg-color));transition:background var(--swui-checkbox-animation-time),border-color var(--swui-checkbox-animation-time);flex-shrink:0}._checkbox_1ndou_1._standard_1ndou_39{width:var(--swui-checkbox-height);height:var(--swui-checkbox-height)}._checkbox_1ndou_1._standard_1ndou_39:after{width:3px;height:6px;left:9px;top:6px}._checkbox_1ndou_1._small_1ndou_51{width:var(--swui-checkbox-height-small);height:var(--swui-checkbox-height-small)}._checkbox_1ndou_1._small_1ndou_51:after{width:3px;height:6px;left:5px;top:2px}._checkbox_1ndou_1:after{content:"";display:block;position:absolute;transition:transform var(--swui-checkbox-animation-time) var(--d-t-e, ease),opacity var(--swui-checkbox-animation-time),width var(--swui-checkbox-animation-time),top var(--swui-checkbox-animation-time);border:2px solid var( --current-checkbox-icon-color, var(--swui-checkbox-unchecked-icon-color) );border-top:0;border-left:0;transform:rotate(var(--current-check-rotation, 20deg));box-sizing:content-box}._checkbox_1ndou_1:checked{--current-check-rotation: 43deg;--current-bg-color: var(--swui-checkbox-checked-bg-color);--current-border-color: var(--swui-checkbox-checked-bg-color);--d-t-e: cubic-bezier(.2, .85, .32, 1.2)}._checkbox_1ndou_1:checked:after{--current-checkbox-icon-color: var(--swui-checkbox-icon-color)}._checkbox_1ndou_1:disabled:not(:checked){--current-bg-color: var(--swui-checkbox-disabled-bg-color);--current-border-color: var(--swui-checkbox-disabled-border-color)}._checkbox_1ndou_1:disabled:not(:checked):after{--current-checkbox-icon-color: --swui-checkbox-unchecked-icon-color}._checkbox_1ndou_1:disabled:checked{--current-bg-color: var(--swui-checkbox-disabled-checked-bg-color);--current-border-color: var(--swui-checkbox-disabled-border-color)}._checkbox_1ndou_1:disabled:checked:after{--current-checkbox-icon-color: var(--swui-checkbox-disabled-icon-color)}._checkbox_1ndou_1:indeterminate{--current-check-rotation: 43deg;--current-bg-color: var(--swui-checkbox-checked-bg-color);--current-border-color: var(--swui-checkbox-checked-bg-color);--d-t-e: cubic-bezier(.2, .85, .32, 1.2)}._checkbox_1ndou_1:indeterminate:after{--current-checkbox-icon-color: var(--swui-checkbox-icon-color);border-right:0;transform:rotate(0);width:6px}._checkbox_1ndou_1:indeterminate._standard_1ndou_39:after{top:4px;left:8px}._checkbox_1ndou_1:indeterminate._small_1ndou_51:after{top:0;left:4px}._checkbox_1ndou_1:indeterminate:disabled:after{--current-checkbox-icon-color: var(--swui-checkbox-disabled-icon-color)}._checkbox_1ndou_1:hover:not(:checked):not(:disabled){--current-border-color: var(--swui-checkbox-border-hover-color)}._checkbox_1ndou_1:focus-visible{outline:var(--swui-focus-outline)}._checkbox_1ndou_1+label{font-size:1.4rem;line-height:var(--swui-checkbox-height);display:inline-block;vertical-align:top;cursor:pointer;margin-left:4px}._radiobutton_foy83_1{--swui-radiobutton-size-standard: var(--swui-field-box-size-medium);--swui-radiobutton-size-small: var(--swui-field-box-size-small);--swui-radiobutton-animation-time: var(--swui-animation-time-medium);--swui-radiobutton-icon-color: var(--swui-field-indicator-active-color);--swui-radiobutton-disabled-icon-color: var(--swui-field-text-color-disabled);--swui-radiobutton-unchecked-icon-color: var( --swui-field-indicator-inactive-color );--swui-radiobutton-checked-bg-color: var(--lhds-color-blue-500);--swui-radiobutton-checked-disabled-bg-color: var(--swui-field-bg-disabled);--swui-radiobutton-unchecked-bg-color: var(--swui-white);--swui-radiobutton-unchecked-disabled-bg-color: var(--swui-field-bg-disabled);--swui-radiobutton-unchecked-border-color: var(--swui-field-border-color);--swui-radiobutton-unchecked-hover-border-color: var( --swui-field-border-color-hover );--swui-radiobutton-disabled-border-color: var( --swui-radiobutton-checked-disabled-bg-color );-webkit-appearance:none;-moz-appearance:none;outline:none;display:inline-block;vertical-align:top;position:relative;margin:0;flex:none;cursor:pointer;border:1px solid var(--current-border-color, var(--swui-radiobutton-unchecked-border-color));border-radius:50%;background:var( --current-bg-color, var(--swui-radiobutton-unchecked-bg-color) );transition:background var(--swui-radiobutton-animation-time),border-color var(--swui-radiobutton-animation-time)}._radiobutton_foy83_1._standard_foy83_45{height:var(--swui-radiobutton-size-standard);width:var(--swui-radiobutton-size-standard)}._radiobutton_foy83_1._standard_foy83_45:after{left:7px;top:7px}._radiobutton_foy83_1._small_foy83_55{height:var(--swui-radiobutton-size-small);width:var(--swui-radiobutton-size-small)}._radiobutton_foy83_1._small_foy83_55:after{left:3px;top:3px}._radiobutton_foy83_1:after{content:"";display:block;position:absolute;transition:transform var(--current-transform-time, var(--swui-radiobutton-animation-time)) var(--current-transform-type, ease),opacity var(--current-opacity-time, var(--swui-radiobutton-animation-time)) var(--current-transform-type, ease);transform:scale(var(--current-scale, 0));width:8px;height:8px;border-radius:50%;background:var( --current-icon-color, var(--swui-radiobutton-unchecked-icon-color) );opacity:var(--current-opacity, 0)}._radiobutton_foy83_1:checked{--current-bg-color: var(--swui-radiobutton-checked-bg-color);--current-border-color: var(--swui-radiobutton-checked-bg-color);--current-opacity-time: var(--swui-radiobutton-animation-time);--current-transform-time: .6s;--current-transform-type: cubic-bezier(.2, .85, .32, 1.2);--current-opacity: 1;--current-scale: 1}._radiobutton_foy83_1:checked:after{--current-icon-color: var(--swui-radiobutton-icon-color)}._radiobutton_foy83_1:disabled{--current-bg-color: var(--swui-radiobutton-unchecked-disabled-bg-color);--current-border-color: var(--swui-radiobutton-disabled-border-color)}._radiobutton_foy83_1:disabled:checked{--current-bg-color: var(--swui-radiobutton-checked-disabled-bg-color)}._radiobutton_foy83_1:disabled:checked:after{--current-icon-color: var(--swui-radiobutton-disabled-icon-color)}._radiobutton_foy83_1:hover:not(:checked):not(:disabled){--current-border-color: var( --swui-radiobutton-unchecked-hover-border-color )}._radiobutton_foy83_1:focus-visible{outline:var(--swui-focus-outline)}._radiobutton_foy83_1+label{font-size:1.4rem;line-height:var(--swui-radiobutton-size-standard);display:inline-block;vertical-align:top;cursor:pointer;margin-left:4px}._radioButtonBox_vpn6v_1{box-sizing:border-box;background-color:var(--lhds-color-ui-200);position:relative;border:1px solid var(--silver-ui);width:100%;border-radius:16px;padding:var(--swui-metrics-space);font-size:var(--swui-font-size-inputs);align-items:center;display:flex;cursor:pointer;outline:none}._radioButtonBox_vpn6v_1:hover{border-color:var(--hav)}._radioButtonBox_vpn6v_1._danger_vpn6v_19{background-color:var(--snackskal-light);border-color:var(--snackskal-light)}._radioButtonBox_vpn6v_1._danger_vpn6v_19:hover{border-color:var(--lhds-color-red-500)}@media (max-width: 768px){._radioButtonWrapper_vpn6v_30{width:100%}}._textInput_1jb3g_1{display:flex;height:var(--swui-field-height);width:100%;align-items:center;background:var(--swui-field-bg-enabled);border:1px solid var(--swui-field-border-color);border-radius:var(--swui-field-border-radius);outline:none}._textInput_1jb3g_1._textInput_1jb3g_1:focus-within:not(._disabled_1jb3g_11){outline:var(--swui-focus-outline);border-color:transparent}._textInput_1jb3g_1 ._input_1jb3g_16{letter-spacing:var(--swui-field-letter-spacing);line-height:var(--swui-field-text-line-height);width:100%;padding:2px var(--swui-metrics-indent);color:var(--swui-field-text-color);font-size:var(--swui-font-size-inputs);font-family:var(--swui-font-input);font-weight:var(--swui-font-weight-inputs);background:var(--swui-hidden);border:none;min-width:0;margin:0;outline:none}._textInput_1jb3g_1 ._input_1jb3g_16:disabled{color:var(--swui-field-text-color-disabled)}._textInput_1jb3g_1 ._input_1jb3g_16::placeholder{color:var(--swui-field-placeholder-color);font-weight:var(--swui-field-placeholder-font-weight)}._textInput_1jb3g_1 ._input_1jb3g_16:focus::placeholder{opacity:0}._textInput_1jb3g_1 ._input_1jb3g_16::-webkit-calendar-picker-indicator{display:none}._textInput_1jb3g_1 ._icon_1jb3g_49{transition:color var(--swui-animation-time-medium);color:var(--swui-field-icon-color);font-size:var(--swui-field-icon-size)}._textInput_1jb3g_1._standard_1jb3g_59:hover:not(:focus-within):not(._disabled_1jb3g_11),._textInput_1jb3g_1._success_1jb3g_60:hover:not(:focus-within):not(._disabled_1jb3g_11){border-color:var(--swui-field-border-color-hover)}._textInput_1jb3g_1._success_1jb3g_60 ._icon_1jb3g_49{color:var(--swui-state-success-color)}._textInput_1jb3g_1._loading_1jb3g_72{background:var(--swui-state-loading-light-color);border-color:var(--swui-state-loading-color)}._textInput_1jb3g_1._modified_1jb3g_77{background:var(--swui-state-modified-light-color);border-color:var(--swui-state-modified-light-color)}._textInput_1jb3g_1._modified_1jb3g_77 ._icon_1jb3g_49{color:var(--lhds-color-blue-300)}._textInput_1jb3g_1._error_1jb3g_86{background:var(--swui-state-error-light-color);border-color:var(--swui-state-error-light-color)}._textInput_1jb3g_1._error_1jb3g_86 ._icon_1jb3g_49{color:var(--swui-state-error-light-color)}._textInput_1jb3g_1._warning_1jb3g_95{background:var(--swui-state-alert-light-color);border-color:var(--swui-state-alert-light-color)}._textInput_1jb3g_1._warning_1jb3g_95 ._icon_1jb3g_49{color:var(--swui-state-alert-light-color)}._textInput_1jb3g_1._disabled_1jb3g_11{background:var(--swui-field-bg-disabled);border-color:var(--swui-field-bg-disabled)}._textInput_1jb3g_1._textInput_1jb3g_1._hideBorder_1jb3g_109{border:none;box-shadow:none;background:none;outline:none}._textInput_1jb3g_1 ._clickable_1jb3g_116:hover{cursor:pointer}._textInput_1jb3g_1 ._clickable_1jb3g_116:hover ._icon_1jb3g_49{color:var(--swui-primary-action-color)}._numericTextInputInput_1tnr6_1{-moz-appearance:textfield}._numericTextInputInput_1tnr6_1::-webkit-outer-spin-button,._numericTextInputInput_1tnr6_1::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}._labelledSelect_1evxo_1{border:1px solid var(--swui-field-border-color);border-radius:var(--swui-border-radius-large);position:relative;overflow:hidden;cursor:pointer}._labelledSelect_1evxo_1._labelledSelect_1evxo_1._onlyTopBorder_1evxo_8{border-bottom-left-radius:0;border-bottom-right-radius:0;border-bottom-color:transparent}._labelledSelect_1evxo_1._onlyBottomBorder_1evxo_14{border-top-left-radius:0;border-top-right-radius:0}._labelledSelect_1evxo_1._error_1evxo_19{border-color:var(--snackskal);background-color:var(--snackskal)}._labelledSelect_1evxo_1._normal_1evxo_24{border-color:var(--swui-field-border-color);background-color:var(--moln)}._labelledSelect_1evxo_1._labelledSelect_1evxo_1:focus-within{border-color:var(--swui-field-border-color-hover);outline:var(--swui-focus-outline);outline-offset:0;z-index:10}._labelledSelect_1evxo_1._labelledSelect_1evxo_1:hover{border-color:var(--swui-field-border-color-hover)}._labelledSelect_1evxo_1 ._label_1evxo_1{display:flex;position:absolute;top:var(--swui-metrics-space);left:calc(var(--swui-metrics-space) * 2);cursor:pointer}._labelledSelect_1evxo_1 ._select_1evxo_48{color:var(--swui-text-primary-color);display:block;margin:0;width:100%;-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;outline:none;font-size:var(--swui-font-size-inputs-large);line-height:1.5;box-sizing:border-box;cursor:pointer;padding:calc(var(--swui-metrics-space) * 5) calc(var(--swui-metrics-space) * 8) calc(var(--swui-metrics-space) * 2) calc(var(--swui-metrics-space) * 2)}._labelledSelect_1evxo_1 ._select_1evxo_48._error_1evxo_19{background-color:var(--snackskal)}._labelledSelect_1evxo_1 ._select_1evxo_48._normal_1evxo_24{background-color:var(--moln)}._labelledSelect_1evxo_1 ._iconWrapper_1evxo_73{border-radius:var(--swui-max-border-radius);width:40px;height:40px;display:flex;flex-direction:column;align-items:center;justify-content:center;position:absolute;top:0;bottom:0;right:calc(var(--swui-metrics-space) * 2);margin-top:auto;margin-bottom:auto;padding:0;background:var(--silver-lighter);pointer-events:none}._labelledTextInput_lnht8_1{position:relative;background:var(--moln);overflow:hidden;cursor:text;border:1px solid var(--silver-light);border-radius:var(--swui-border-radius)}._labelledTextInput_lnht8_1 input{outline:none;border:none;margin:0;color:var(--swui-text-primary-color);background-color:transparent;line-height:var(--swui-line-height);width:100%;box-sizing:border-box;cursor:text}._labelledTextInput_lnht8_1._labelledTextInput_lnht8_1._onlyTop_lnht8_21{border-bottom-left-radius:0;border-bottom-right-radius:0;border-bottom-color:transparent}._labelledTextInput_lnht8_1._labelledTextInput_lnht8_1._onlyBottom_lnht8_27{border-top-left-radius:0;border-top-right-radius:0}._labelledTextInput_lnht8_1:focus-within{outline:var(--swui-focus-outline);outline-offset:-1px;border-color:transparent}._labelledTextInput_lnht8_1:hover:not(:focus-within){border-color:var(--hav)}._labelledTextInput_lnht8_1._disabled_lnht8_42{background-color:var(--silver-lighter)}._labelledTextInput_lnht8_1._disabled_lnht8_42 input{color:var(--silver)}._labelledTextInput_lnht8_1._medium_lnht8_50:focus-within{outline-width:2px}._labelledTextInput_lnht8_1._medium_lnht8_50 input{font-size:var(--swui-font-size-inputs);padding:calc(var(--swui-metrics-space) * 4) calc(var(--swui-metrics-space) * 2) calc(var(--swui-metrics-space) * 1)}._labelledTextInput_lnht8_1._large_lnht8_62{border-radius:var(--swui-border-radius-large)}._labelledTextInput_lnht8_1._large_lnht8_62:focus-within{outline-width:3px}._labelledTextInput_lnht8_1._large_lnht8_62 input{font-size:var(--swui-font-size-inputs-large);padding:calc(var(--swui-metrics-space) * 5) calc(var(--swui-metrics-space) * 2) calc(var(--swui-metrics-space) * 2)}._labelledTextInput_lnht8_1._error_lnht8_76{border-color:var(--swui-state-error-light-color)}._labelledTextInput_lnht8_1._error_lnht8_76:hover:not(:focus-within){border-color:var(--modern-red)}._labelledTextInput_lnht8_1._error_lnht8_76 input{background-color:var(--swui-state-error-light-color)}._labelledTextInput_lnht8_1 label{display:flex;position:absolute;top:var(--swui-metrics-space);left:calc(var(--swui-metrics-space) * 2);cursor:text}._textArea_6n6nc_1{--swui-textarea-text-color: var(--swui-field-text-color);--swui-textarea-text-color-disabled: var(--swui-field-text-color-disabled);--swui-textarea-letter-spacing: var(--swui-field-letter-spacing);--swui-textarea-line-height: var(--swui-field-text-line-height);--swui-textarea-indent: var(--swui-metrics-indent);--swui-textarea-font-size: var(--swui-font-size-inputs);--swui-textarea-font-family: var(--swui-font-input);--swui-textarea-font-weight: var(--swui-font-weight-inputs);--swui-textarea-placeholder-color: var(--swui-text-disabled-color);--swui-textarea-animation-time: var(--swui-animation-time-medium);--swui-textarea-icon-color: var(--swui-field-border-color-disabled);--swui-textarea-icon-size: var(--swui-field-icon-size);--swui-textarea-icon-color-success: var(--swui-state-success-color);--swui-textarea-bg-loading: var(--swui-state-loading-light-color);--swui-textarea-border-color-loading: var(--swui-state-loading-color);--swui-textarea-bg-modified: var(--swui-state-modified-light-color);--swui-textarea-border-color-modified: var(--swui-state-modified-color);--swui-textarea-bg-warning: var(--swui-state-alert-light-color);--swui-textarea-border-color-warning: var(--swui-state-alert-color);--swui-textarea-bg-error: var(--swui-state-error-light-color);--swui-textarea-border-color-error: var(--swui-state-error-color);--swui-textarea-bg-color: var(--swui-field-bg-enabled);--swui-textarea-bg-color-disabled: var(--swui-field-bg-disabled);--swui-textarea-border-radius: var(--swui-field-border-radius);--swui-textarea-border-color: var(--swui-field-border-color);--swui-textarea-border-color-hover: var(--swui-field-border-color-hover);--swui-textarea-border-color-disabled: var( --swui-field-border-color-disabled );max-width:100%;letter-spacing:var(--swui-textarea-letter-spacing);line-height:var(--swui-textarea-line-height);padding:2px var(--swui-textarea-indent);color:var(--swui-textarea-text-color);font-size:var(--swui-textarea-font-size);font-family:var(--swui-textarea-font-family);font-weight:var(--swui-textarea-font-weight);background:var(--current-bg, var(--swui-textarea-bg-color));border:1px solid var(--current-border-color, var(--swui-textarea-border-color));border-radius:var(--swui-textarea-border-radius);transition:border var(--swui-textarea-animation-time);--current-icon-color: var(--swui-textarea-icon-color)}._textArea_6n6nc_1:focus:not(:focus-visible){outline:none}._textArea_6n6nc_1:focus{--current-border-color: var(--swui-textarea-border-color-hover);--current-bg: var(--swui-textarea-bg-color)}._textArea_6n6nc_1:focus-visible{outline:var(--swui-focus-outline)}._textArea_6n6nc_1:disabled{color:var(--swui-textarea-text-color-disabled);--current-bg: var(--swui-textarea-bg-color-disabled);--current-border-color: var(--swui-textarea-border-color-disabled)}')),document.head.appendChild(o)}}catch(r){console.error("vite-plugin-css-injected-by-js",r)}})();
import { jsx as o, jsxs as b, Fragment as S } from "react/jsx-runtime";
import { Box as pt, Space as x, Text as N, Row as T, ScreenReaderOnlyText as M, parseFloatElseUndefined as H, getDataProps as ft } from "@stenajs-webui/core";
import * as mt from "react";
import { forwardRef as W, useRef as P, useCallback as g, useEffect as z, useMemo as bt, useState as ht, useId as O } from "react";
import h from "classnames";
import { Icon as D, stenaCheck as E, stenaExclamationTriangle as G, InputSpinner as X, UpDownButtons as xt, TextInputButton as $, stenaEyeShow as yt, stenaEyeHide as It, stenaAngleDown as gt } from "@stenajs-webui/elements";
import { FontAwesomeIcon as wt } from "@fortawesome/react-fontawesome";
import { cssColor as q } from "@stenajs-webui/theme";
const Bt = "_knob_1d6s8_56", Tt = "_filler_1d6s8_61", kt = "_checked_1d6s8_75", v = {
  switch: "_switch_1d6s8_1",
  knob: Bt,
  filler: Tt,
  checked: kt
}, St = `${v.switch} ${v.checked}`, vt = ({
  value: t,
  disabled: e,
  onValueChange: n,
  className: r,
  wrapperRef: c,
  ...s
}) => /* @__PURE__ */ o("div", { className: r, ref: c, children: /* @__PURE__ */ b(
  "button",
  {
    type: "button",
    role: "switch",
    "aria-checked": t,
    className: t ? St : v.switch,
    disabled: e,
    onClick: () => n && n(!t),
    ...s,
    children: [
      /* @__PURE__ */ o("div", { className: v.filler }),
      /* @__PURE__ */ o("div", { className: v.knob })
    ]
  }
) }), Re = ({
  label: t,
  disabled: e,
  textColor: n,
  wrapperRef: r,
  ...c
}) => /* @__PURE__ */ o("div", { ref: r, children: /* @__PURE__ */ o("label", { children: /* @__PURE__ */ b(pt, { row: !0, alignItems: "center", children: [
  /* @__PURE__ */ o(vt, { disabled: e, ...c }),
  /* @__PURE__ */ o(x, {}),
  /* @__PURE__ */ o(N, { userSelect: "none", color: n, children: t })
] }) }) }), Nt = "_checkbox_1ndou_1", Rt = "_standard_1ndou_39", jt = "_small_1ndou_51", F = {
  checkbox: Nt,
  standard: Rt,
  small: jt
}, $t = W(
  ({
    indeterminate: t = !1,
    onChange: e,
    onValueChange: n,
    value: r = !1,
    size: c = "standard",
    className: s,
    ...l
  }, a) => {
    const i = P(), f = (u) => {
      i.current = u, i.current && (i.current.indeterminate = !!t), a && (typeof a == "function" ? a(u) : a.current = u);
    }, _ = g(
      (u) => {
        e && e(u), n && n(u.target.checked);
      },
      [e, n]
    );
    return z(() => {
      i.current && (i.current.indeterminate = !!t);
    }, [t, i]), /* @__PURE__ */ o(
      "input",
      {
        type: "checkbox",
        className: h(F.checkbox, F[c], s),
        checked: r,
        onChange: _,
        ref: f,
        ...l
      }
    );
  }
), je = ({
  children: t,
  label: e,
  inputRef: n,
  wrapperRef: r,
  textColor: c,
  ...s
}) => /* @__PURE__ */ o("div", { ref: r, children: /* @__PURE__ */ o("label", { children: /* @__PURE__ */ b(T, { alignItems: "center", children: [
  /* @__PURE__ */ o($t, { ...s, ref: n }),
  /* @__PURE__ */ o(x, {}),
  e && /* @__PURE__ */ o(N, { userSelect: "none", color: c, children: e }),
  t
] }) }) }), At = "_radiobutton_foy83_1", Ht = "_standard_foy83_45", Wt = "_small_foy83_55", L = {
  radiobutton: At,
  standard: Ht,
  small: Wt
}, J = W(
  ({
    onChange: t,
    onValueChange: e,
    size: n = "standard",
    name: r,
    className: c,
    ...s
  }, l) => {
    const a = g(
      (i) => {
        t && t(i), e && e(i.target.value);
      },
      [t, e]
    );
    return /* @__PURE__ */ o(
      "input",
      {
        type: "radio",
        name: r,
        className: h(L.radiobutton, L[n], c),
        onChange: a,
        ref: l,
        ...s
      }
    );
  }
), Pt = "_radioButtonBox_vpn6v_1", Ut = "_danger_vpn6v_19", Ft = "_radioButtonWrapper_vpn6v_30", K = {
  radioButtonBox: Pt,
  danger: Ut,
  radioButtonWrapper: Ft
}, $e = ({
  label: t,
  screenReaderLabel: e,
  variant: n = "normal",
  icon: r,
  className: c,
  style: s,
  radioButtonClassName: l,
  ...a
}) => /* @__PURE__ */ o(
  "label",
  {
    className: h(K.radioButtonBox, K[n], c),
    style: s,
    children: /* @__PURE__ */ b(T, { justifyContent: "space-between", flexGrow: 1, children: [
      /* @__PURE__ */ b(T, { alignItems: "center", children: [
        /* @__PURE__ */ o(J, { ...a, className: l }),
        /* @__PURE__ */ o(x, {}),
        e ? /* @__PURE__ */ o(M, { children: e }) : null,
        /* @__PURE__ */ o(N, { "aria-hidden": !!e, children: t })
      ] }),
      /* @__PURE__ */ o(T, { alignItems: "center", width: "48px", justifyContent: "center", children: r && /* @__PURE__ */ o(D, { icon: r, size: 24 }) })
    ] })
  }
), Ae = ({
  label: t,
  inputRef: e,
  wrapperRef: n,
  textColor: r,
  ...c
}) => /* @__PURE__ */ o("div", { ref: n, children: /* @__PURE__ */ o("label", { children: /* @__PURE__ */ b(T, { alignItems: "center", children: [
  /* @__PURE__ */ o(J, { ref: e, ...c }),
  /* @__PURE__ */ o(x, {}),
  /* @__PURE__ */ o(N, { color: r, userSelect: "none", children: t })
] }) }) }), Lt = (t, e, n, r, c, s, l, a) => {
  const i = P(!1), f = (d) => {
    i.current || s == null || s(d.target.value ?? ""), l == null || l(d);
  }, _ = (d) => {
    i.current = !1, a == null || a(d);
  };
  return {
    onKeyDownHandler: g(
      (d) => {
        const { key: p } = d;
        if (p === "Enter")
          i.current = !0, n == null || n(), s == null || s(d.currentTarget.value ?? "");
        else if (p === "Escape")
          i.current = !0, r == null || r(), d.preventDefault(), d.stopPropagation();
        else if (c) {
          const m = (w, y) => {
            i.current = !0, t.current.blur(), c(w), y.preventDefault(), y.stopPropagation();
          };
          d.shiftKey && p === "Tab" ? m("left", d) : p === "Tab" ? m("right", d) : p === "ArrowUp" ? m("up", d) : p === "ArrowDown" ? m("down", d) : p === "ArrowRight" ? t.current.value.length === t.current.selectionStart && m("right", d) : p === "ArrowLeft" && t.current.selectionStart === 0 && m("left", d);
        }
        e && e(d);
      },
      [r, c, e, t, n, s]
    ),
    onBlurHandler: f,
    onFocusHandler: _
  };
};
function Kt(t) {
  return t.tagName === "TEXTAREA" || t.tagName === "INPUT" && (t.type === "text" || t.type === "search" || t.type === "url" || t.type === "tel" || t.type === "password");
}
const Mt = (t, e, n) => {
  z(() => {
    t.current && Kt(t.current) && (n ? t.current.setSelectionRange(0, t.current.value.length) : e && t.current.setSelectionRange(
      t.current.value.length,
      t.current.value.length
    ));
  }, [e, t, n]);
}, zt = (t, {
  onEnter: e,
  onEsc: n,
  onChange: r,
  onValueChange: c,
  selectAllOnMount: s,
  moveCursorToEndOnMount: l,
  onDone: a,
  onMove: i,
  onFocus: f,
  onBlur: _,
  onKeyDown: u,
  autoFocus: d
}) => {
  Mt(t, !!l, !!s);
  const { onKeyDownHandler: p, onFocusHandler: m, onBlurHandler: w } = Lt(
    t,
    u,
    e,
    n,
    i,
    a,
    _,
    f
  ), y = g(
    (R) => {
      r == null || r(R), c == null || c(R.target.value);
    },
    [r, c]
  );
  return {
    onBlur: w,
    onChange: y,
    onFocus: m,
    onKeyDown: p,
    autoFocus: s || d
  };
}, Ot = "_textInput_1jb3g_1", Dt = "_disabled_1jb3g_11", Et = "_input_1jb3g_16", Gt = "_icon_1jb3g_49", Xt = "_standard_1jb3g_59", qt = "_success_1jb3g_60", Jt = "_loading_1jb3g_72", Qt = "_modified_1jb3g_77", Yt = "_error_1jb3g_86", Zt = "_warning_1jb3g_95", Ct = "_hideBorder_1jb3g_109", Vt = "_clickable_1jb3g_116", I = {
  textInput: Ot,
  disabled: Dt,
  input: Et,
  icon: Gt,
  standard: Xt,
  success: qt,
  loading: Jt,
  modified: Qt,
  error: Yt,
  warning: Zt,
  hideBorder: Ct,
  clickable: Vt
}, j = ({
  button: t,
  icon: e,
  iconClassName: n,
  content: r,
  spaceOnLeft: c,
  spaceOnRight: s,
  disableContentPadding: l,
  disableContentPaddingLeft: a,
  disableContentPaddingRight: i
}) => !r && !e && !t ? null : t ? /* @__PURE__ */ b(S, { children: [
  c ? /* @__PURE__ */ o(x, { num: 0.25 }) : null,
  t,
  s ? /* @__PURE__ */ o(x, { num: 0.25 }) : null
] }) : r ? /* @__PURE__ */ b(S, { children: [
  c && !(l || a) ? /* @__PURE__ */ o(x, {}) : null,
  r || null,
  s && !(l || i) ? /* @__PURE__ */ o(x, {}) : null
] }) : /* @__PURE__ */ b(S, { children: [
  c ? /* @__PURE__ */ o(x, {}) : null,
  e && /* @__PURE__ */ o(
    wt,
    {
      icon: e,
      className: h(I.icon, n)
    }
  ),
  s ? /* @__PURE__ */ o(x, {}) : null
] }), Q = (t) => {
  const {
    variant: e = "standard",
    inputRef: n,
    disabled: r,
    className: c,
    buttonLeft: s,
    buttonRight: l,
    contentLeft: a,
    contentRight: i,
    disableContentPadding: f,
    disableContentPaddingLeft: _,
    disableContentPaddingRight: u,
    iconLeft: d,
    iconRight: p,
    moveCursorToEndOnMount: m,
    selectAllOnMount: w,
    autoFocus: y,
    onValueChange: R,
    wrapperClassName: Z,
    wrapperStyle: C,
    onDone: V,
    onEnter: tt,
    onEsc: et,
    onMove: rt,
    onChange: nt,
    onKeyDown: ot,
    hideBorder: ct,
    onFocus: st,
    onBlur: lt,
    ...it
  } = t, at = P(null), U = n ?? at, dt = zt(U, {
    onEnter: tt,
    onEsc: et,
    onChange: nt,
    onValueChange: R,
    selectAllOnMount: w,
    moveCursorToEndOnMount: m,
    onDone: V,
    onMove: rt,
    onFocus: st,
    onBlur: lt,
    onKeyDown: ot,
    autoFocus: y
  }), ut = e === "success" ? E : e === "warning" || e === "error" ? G : p, _t = e === "loading" ? /* @__PURE__ */ o(X, {}) : i;
  return /* @__PURE__ */ b(
    "div",
    {
      className: h(
        I.textInput,
        I[e],
        {
          [I.disabled]: r
        },
        {
          [I.hideBorder]: ct
        },
        Z
      ),
      style: C,
      children: [
        /* @__PURE__ */ o(
          j,
          {
            content: a,
            disableContentPadding: f,
            disableContentPaddingLeft: _,
            disableContentPaddingRight: u,
            icon: d,
            spaceOnLeft: !0,
            button: s
          }
        ),
        /* @__PURE__ */ o(
          "input",
          {
            className: h(I.input, c),
            type: "text",
            disabled: r,
            ref: U,
            autoFocus: y,
            ...it,
            ...dt
          }
        ),
        /* @__PURE__ */ o(
          j,
          {
            content: _t,
            disableContentPadding: f,
            disableContentPaddingLeft: _,
            disableContentPaddingRight: u,
            icon: ut,
            spaceOnRight: !0,
            button: l
          }
        )
      ]
    }
  );
}, te = "_numericTextInputInput_1tnr6_1", ee = {
  numericTextInputInput: te
}, re = ({
  onValueChange: t,
  value: e,
  numSteps: n,
  min: r,
  max: c
}) => {
  if (t)
    if (!e)
      t(String(A(n, r, c)));
    else {
      const l = (H(e) || 0) + n;
      t(String(A(l, r, c)));
    }
}, ne = ({
  onValueChange: t,
  newValue: e,
  min: n,
  max: r
}) => {
  if (t)
    if (e === "")
      t("");
    else {
      const s = H(e) || 0;
      t(String(A(s, n, r)));
    }
}, A = (t, e, n) => {
  let r = t;
  return e != null && (r = Math.max(e, r)), n != null && (r = Math.min(n, r)), r;
}, He = ({
  value: t,
  onValueChange: e,
  max: n,
  min: r,
  step: c = 1,
  contentRight: s,
  disabled: l,
  className: a,
  hideButtons: i,
  ...f
}) => {
  const _ = g(
    (p) => {
      re({ onValueChange: e, value: t, numSteps: p, min: r, max: n });
    },
    [t, n, r, e]
  ), u = g(
    (p) => {
      ne({ onValueChange: e, newValue: p, min: r, max: n });
    },
    [n, r, e]
  );
  return /* @__PURE__ */ o(
    Q,
    {
      contentRight: i ? s : /* @__PURE__ */ b(S, { children: [
        s && /* @__PURE__ */ b(S, { children: [
          s,
          /* @__PURE__ */ o(x, {})
        ] }),
        /* @__PURE__ */ o(
          xt,
          {
            onClickUp: l ? void 0 : () => _(c),
            onClickDown: l ? void 0 : () => _(-c),
            iconColor: "var(--swui-textinput-text-color)",
            disabled: l
          }
        )
      ] }),
      value: t,
      onValueChange: u,
      disableContentPaddingRight: !i,
      type: "number",
      min: r,
      max: n,
      step: c,
      className: h(ee.numericTextInputInput, a),
      disabled: l,
      ...f
    }
  );
}, We = (t, e) => {
  const n = g(
    (c) => {
      if (e)
        if (!c)
          e(void 0);
        else {
          const s = H(c);
          s !== void 0 && e(s);
        }
    },
    [e]
  ), r = bt(() => t === void 0 ? "" : String(t), [t]);
  return {
    onValueChange: n,
    value: r
  };
}, Pe = ({
  hiddenIcon: t = yt,
  visibleIcon: e = It,
  ...n
}) => {
  const [r, c] = ht(!0);
  return /* @__PURE__ */ o(
    Q,
    {
      buttonRight: /* @__PURE__ */ o(
        $,
        {
          icon: r ? t : e,
          onClick: () => c((s) => !s)
        }
      ),
      type: r ? "password" : "text",
      ...n
    }
  );
}, oe = ({
  disabled: t,
  text: e,
  ...n
}) => /* @__PURE__ */ o(
  N,
  {
    variant: "bold",
    color: q(t ? "--silver" : "--tjara"),
    size: "small",
    ...ft(n),
    children: e
  }
), Y = ({
  htmlFor: t,
  screenReaderLabel: e,
  label: n,
  disabled: r,
  className: c
}) => /* @__PURE__ */ b("label", { htmlFor: t, className: c, children: [
  e ? /* @__PURE__ */ o(M, { children: e }) : null,
  /* @__PURE__ */ o(
    oe,
    {
      "aria-hidden": !!e,
      text: n,
      disabled: r
    }
  )
] }), ce = "_labelledSelect_1evxo_1", se = "_onlyTopBorder_1evxo_8", le = "_onlyBottomBorder_1evxo_14", ie = "_error_1evxo_19", ae = "_normal_1evxo_24", de = "_label_1evxo_1", ue = "_select_1evxo_48", _e = "_iconWrapper_1evxo_73", B = {
  labelledSelect: ce,
  onlyTopBorder: se,
  onlyBottomBorder: le,
  error: ie,
  normal: ae,
  label: de,
  select: ue,
  iconWrapper: _e
}, Ue = ({
  onChange: t,
  onValueChange: e,
  id: n,
  label: r,
  screenReaderLabel: c,
  borderVariant: s = "normalBorder",
  variant: l = "normal",
  children: a,
  ...i
}) => {
  const f = O(), _ = n ?? f, u = g(
    (d) => {
      t == null || t(d), e == null || e(d.target.value);
    },
    [t, e]
  );
  return /* @__PURE__ */ b(
    "div",
    {
      className: h(
        B.labelledSelect,
        B[l],
        B[s]
      ),
      children: [
        /* @__PURE__ */ o(
          Y,
          {
            htmlFor: _,
            className: B.label,
            label: r,
            screenReaderLabel: c
          }
        ),
        /* @__PURE__ */ o(
          "select",
          {
            id: _,
            onChange: u,
            className: h(B.select, B[l]),
            ...i,
            children: a
          }
        ),
        /* @__PURE__ */ o("div", { className: h(B.iconWrapper), children: /* @__PURE__ */ o(
          D,
          {
            icon: gt,
            size: 24,
            color: q("--modern-blue")
          }
        ) })
      ]
    }
  );
}, pe = "_labelledTextInput_lnht8_1", fe = "_onlyTop_lnht8_21", me = "_onlyBottom_lnht8_27", be = "_disabled_lnht8_42", he = "_medium_lnht8_50", xe = "_large_lnht8_62", ye = "_error_lnht8_76", k = {
  labelledTextInput: pe,
  onlyTop: fe,
  onlyBottom: me,
  disabled: be,
  medium: he,
  large: xe,
  error: ye
}, Fe = mt.forwardRef(
  ({
    autoComplete: t = "off",
    label: e,
    id: n,
    screenReaderLabel: r,
    size: c = "medium",
    value: s,
    onChange: l,
    disabled: a,
    onValueChange: i,
    borderRadiusVariant: f = "normalBorder",
    variant: _ = "normal",
    ...u
  }, d) => {
    const p = O(), m = n ?? p, w = g(
      (y) => {
        l == null || l(y), i == null || i(y.target.value);
      },
      [l, i]
    );
    return /* @__PURE__ */ b(
      "div",
      {
        className: h(
          k.labelledTextInput,
          k[_],
          k[f],
          k[c],
          a && k.disabled
        ),
        children: [
          /* @__PURE__ */ o(
            Y,
            {
              htmlFor: m,
              screenReaderLabel: r,
              label: e
            }
          ),
          /* @__PURE__ */ o(
            "input",
            {
              ref: d,
              id: m,
              autoComplete: t,
              type: "text",
              value: s,
              onChange: w,
              disabled: a,
              ...u
            }
          )
        ]
      }
    );
  }
), Le = ({
  variant: t = "standard",
  disabled: e,
  wrapperClassName: n,
  wrapperStyle: r,
  contentLeft: c,
  contentRight: s,
  disableContentPadding: l,
  disableContentPaddingLeft: a,
  disableContentPaddingRight: i,
  iconRight: f,
  iconLeft: _,
  onClickLeft: u,
  onClickRight: d,
  children: p
}) => {
  const m = t === "success" ? E : t === "warning" || t === "error" ? G : f, w = t === "loading" ? /* @__PURE__ */ o(X, {}) : s;
  return /* @__PURE__ */ b(
    "div",
    {
      className: h(
        I.textInput,
        I.inputContainer,
        I[t],
        {
          [I.disabled]: e
        },
        n
      ),
      style: r,
      children: [
        /* @__PURE__ */ o(
          j,
          {
            content: c,
            disableContentPadding: l,
            disableContentPaddingLeft: a,
            disableContentPaddingRight: i,
            spaceOnLeft: !0,
            button: _ ? /* @__PURE__ */ o($, { onClick: u, icon: _ }) : void 0
          }
        ),
        /* @__PURE__ */ o(T, { alignItems: "center", children: p }),
        /* @__PURE__ */ o(
          j,
          {
            content: w,
            disableContentPadding: l,
            disableContentPaddingLeft: a,
            disableContentPaddingRight: i,
            spaceOnRight: !0,
            button: m ? /* @__PURE__ */ o($, { onClick: d, icon: m }) : void 0
          }
        )
      ]
    }
  );
}, Ie = "_textArea_6n6nc_1", ge = {
  textArea: Ie
}, Ke = W(
  ({
    className: t,
    value: e,
    onValueChange: n,
    onChange: r,
    resize: c = "none",
    readOnly: s = !1,
    rows: l,
    disabled: a,
    ...i
  }, f) => {
    const _ = g(
      (u) => {
        r && r(u), n && n(u.target.value);
      },
      [r, n]
    );
    return /* @__PURE__ */ o(
      "textarea",
      {
        disabled: a,
        rows: l,
        readOnly: s,
        className: h(ge.textArea, t),
        style: { resize: c },
        onChange: _,
        value: e,
        ref: f,
        ...i
      }
    );
  }
);
export {
  $t as Checkbox,
  je as CheckboxWithLabel,
  Y as InputLabel,
  oe as InputLabelText,
  Ue as LabelledSelect,
  Fe as LabelledTextInput,
  He as NumericTextInput,
  Pe as PasswordInput,
  J as RadioButton,
  $e as RadioButtonBox,
  Ae as RadioButtonWithLabel,
  vt as Switch,
  Re as SwitchWithLabel,
  Ke as TextArea,
  Q as TextInput,
  Le as TextInputBox,
  Kt as elementHasSelectionRange,
  re as onStepValueChange,
  ne as onTextValueChange,
  Lt as useKeyboardNavigation,
  We as useNumericInputValue,
  Mt as useSelectAllOnMount,
  zt as useTextInput
};
//# sourceMappingURL=index.es.js.map
